import styled from 'styled-components';
import { Colors } from '../../../ui';

export const StatsGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    gap: 0.5rem;
    padding: 0 .5rem;
    border: 1px solid ${Colors.border};
    border-radius: .25rem;
`;

export const StatsGroupDivider = styled.div`
    width: 1px;
    height: 1.25rem;
    background: rgba(59, 101, 239, 0.5);
`;
